import React, { useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { CheckLogin } from './services/userservice';
function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async () => {
        try {
            const postBody = JSON.stringify({
                username: username,
                password: password
            });
            
            const loginResponse = await CheckLogin(postBody);
            const jsonDataList = JSON.parse(loginResponse);
            console.log("jsonDataList:", jsonDataList);
            if(jsonDataList.isloggedin)
            {
                localStorage.setItem('isloggedin', true); 
                localStorage.setItem('fullname', jsonDataList.fullname); 
                localStorage.setItem('userpk', jsonDataList.pk); 
                localStorage.setItem('usertype', jsonDataList.usertype); 
                localStorage.setItem('photourl', jsonDataList.photourl); 
                window.location.href = '/'; // Redirect to home
            }
            else{
                toast(jsonDataList.message);
            }

        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }
    
    return (
        <>
            <div class="container-scroller">
                <div class="container-fluid page-body-wrapper full-page-wrapper">
                    <div class="content-wrapper d-flex align-items-center auth px-0">
                        <div class="row w-100 mx-0">
                            <div class="col-lg-4 mx-auto">
                                <div class="auth-form-light text-left py-5 px-4 px-sm-5">
                                    {/* 
                                    <div class="brand-logo">
                                        <img src="../../assets/images/logo.svg" alt="logo" />
                                    </div>
                                    <h4>Hello! let's get started</h4>
                                    <h6 class="font-weight-light">Sign in to continue.</h6> */}
                                    {/* <form class="pt-3"> */}
                                    <div class="form-group">
                                        <input type="text" class="form-control form-control-lg" id="txtUsername" placeholder="Username" onChange={(e) => setUsername(e.target.value)} value={username} />
                                    </div>
                                    <div class="form-group">
                                        <input type="password" class="form-control form-control-lg" id="txtPassword" placeholder="Password" onChange={(e) => setPassword(e.target.value)} value={password} />
                                    </div>
                                    <div class="mt-3 d-grid gap-2">
                                        <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" href="#" onClick={() => handleLogin()}>SIGN IN</a>
                                    </div>
                                    {/* <div class="my-2 d-flex justify-content-between align-items-center">
                                            <div class="form-check">
                                                <label class="form-check-label text-muted">
                                                    <input type="checkbox" class="form-check-input" /> Keep me signed in </label>
                                            </div>
                                            <a href="#" class="auth-link text-black">Forgot password?</a>
                                        </div>
                                        <div class="mb-2 d-grid gap-2">
                                            <button type="button" class="btn btn-block btn-facebook auth-form-btn">
                                                <i class="ti-facebook me-2"></i>Connect using facebook </button>
                                        </div>
                                        <div class="text-center mt-4 font-weight-light"> Don't have an account? <a href="register.html" class="text-primary">Create</a>
                                        </div> */}
                                    {/* </form> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- content-wrapper ends --> */}
                </div>
                {/* <!-- page-body-wrapper ends --> */}
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}
export default LoginPage;